export default __webpack_public_path__ + "static/media/Buttock.d8012181.svg";